import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Terms of Service</h1>
            <p className="text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div className="prose prose-blue max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-6">
              By accessing and using WebFit Nation, you accept and agree to be bound by the terms 
              and provision of this agreement. If you do not agree to abide by the above, please 
              do not use this service.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
            <p className="text-gray-700 mb-4">
              WebFit Nation provides fitness tracking, workout planning, and nutrition management 
              services. Our platform includes:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-6">
              <li>Personalized workout and meal plans</li>
              <li>Progress tracking and analytics</li>
              <li>Communication tools with fitness professionals</li>
              <li>Educational content and resources</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. User Accounts</h2>
            <p className="text-gray-700 mb-4">
              To use our services, you must:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-6">
              <li>Be at least 18 years old or have parental consent</li>
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Accept responsibility for all activities under your account</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Acceptable Use</h2>
            <p className="text-gray-700 mb-4">
              You agree not to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-6">
              <li>Use the service for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt the service</li>
              <li>Share your account credentials with others</li>
              <li>Upload harmful or inappropriate content</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Health Disclaimer</h2>
            <p className="text-gray-700 mb-6">
              WebFit Nation is not a substitute for professional medical advice, diagnosis, or 
              treatment. Always consult with qualified healthcare professionals before starting 
              any fitness program. We are not responsible for any injuries or health issues 
              that may result from using our services.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Privacy and Data</h2>
            <p className="text-gray-700 mb-6">
              Your privacy is important to us. Please review our Privacy Policy, which also 
              governs your use of the service, to understand our practices regarding the 
              collection and use of your information.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Intellectual Property</h2>
            <p className="text-gray-700 mb-6">
              The service and its original content, features, and functionality are owned by 
              WebFit Nation and are protected by international copyright, trademark, patent, 
              trade secret, and other intellectual property laws.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Termination</h2>
            <p className="text-gray-700 mb-6">
              We may terminate or suspend your account immediately, without prior notice, 
              for conduct that we believe violates these Terms of Service or is harmful to 
              other users, us, or third parties.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Limitation of Liability</h2>
            <p className="text-gray-700 mb-6">
              In no event shall WebFit Nation be liable for any indirect, incidental, special, 
              consequential, or punitive damages, including without limitation, loss of profits, 
              data, use, goodwill, or other intangible losses.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Changes to Terms</h2>
            <p className="text-gray-700 mb-6">
              We reserve the right to modify these terms at any time. We will notify users 
              of any material changes via email or through the service. Your continued use 
              of the service after such modifications constitutes acceptance of the updated terms.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Contact Information</h2>
            <p className="text-gray-700 mb-6">
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <div className="bg-gray-50 p-4 rounded-md">
              <p className="text-gray-700">
                <strong>Email:</strong> legal@webfitnation.com<br />
                <strong>Address:</strong> WebFit Nation, Legal Team<br />
                <strong>Phone:</strong> (555) 123-4567
              </p>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link
              to="/register"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
            >
              ← Back to Registration
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
